import { createColumnProps } from "./_builder";
import { colDate } from "./dates";

export const colCreatedDate = createColumnProps(colDate, {
  classes: "w-20",
  dataField: "createdDate",
  text: "Created Date",
});

export const colModifiedDate = createColumnProps(colDate, {
  classes: "w-20",
  dataField: "modifiedDate",
  text: "Modified Date",
});

export const colId = {
  dataField: "id",
  hidden: true,
  text: "ID",
};

